(function ($) {
  var text_max = 250;
  var counter_wrapper = $(".counter");
  var counter;
  var textarea;

  if (counter_wrapper) {
    counter_wrapper
      .find("label")
      .after("<span class=\"textarea-character-count\"></span>");

    counter = counter_wrapper.find("span.textarea-character-count");
    textarea = counter_wrapper.find("textarea");

    textarea.attr("maxlength", 250);

    counter.html("(" + text_max + " karakters over)");

    textarea.keyup(function () {
      if ($(this).parent().prev(".textarea-character-count")) {
        var text_length = $(this).val().length;
        var text_remaining = text_max - text_length;

        if (text_remaining != 1) {
          counter.html("(" + text_remaining + " karakters over)");
        } else {
          counter.html("(" + text_remaining + " karakter over)");
        }

        if (text_length == 250) {
          counter.html("Maximaal aantal karakters bereikt!");
        }
      }
    });
  }
})(jQuery);
